import { render, staticRenderFns } from "./label.vue?vue&type=template&id=52c5c5ec&scoped=true"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"
import style0 from "./label.vue?vue&type=style&index=0&id=52c5c5ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5c5ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c5c5ec')) {
      api.createRecord('52c5c5ec', component.options)
    } else {
      api.reload('52c5c5ec', component.options)
    }
    module.hot.accept("./label.vue?vue&type=template&id=52c5c5ec&scoped=true", function () {
      api.rerender('52c5c5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowShopManagement/components/label.vue"
export default component.exports